import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {  DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchSuppliersListComponent } from './ECRANS/RECHERCHE_FOURNISSEURS/search-suppliers/search-suppliers.component';
import { ErrorsInterceptor } from './interceptors/errors.interceptor';
import { LockedUserInterceptor } from './interceptors/locked-user.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NewSupplierComponent } from './ECRANS/DEMANDE_REFERENCEMENT/new-supplier/new-supplier.component';
import { HomeComponent } from './ECRANS/home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {  registerLocaleData } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ExtusersListsComponent } from './ECRANS/COMPTES_EXTERNES/extusers-lists/extusers-lists.component';
import localFr from '@angular/common/locales/fr';
import localEn from '@angular/common/locales/en';
import { pafEnvironment,azureEnvironnent } from 'localEnvironments/environment';
registerLocaleData(localFr);
registerLocaleData(localEn);


import "@progress/kendo-angular-intl/locales/fr/all";
import {OverlayModule} from '@angular/cdk/overlay';

import {
  MsalGuard,
  MsalService,
  MsalModule, MsalInterceptor,
} from '@azure/msal-angular';

import {InteractionType, IPublicClientApplication,  PublicClientApplication} from '@azure/msal-browser';
import { 
  SharedDataModule,
  PafCommonModule, 
  JsonDateInterceptor,
  ENV
} from 'ngx-paf-common';
import { SourcingComponent } from './ECRANS/LISTES/sourcing/sourcing.component';
import { LstTasksComponent } from './ECRANS/LISTES/lst-tasks/lst-tasks.component';
import {LstEncoursComponent} from './ECRANS/LISTES/lst-encours/lst-encours.component';
import { PilotageEndelComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-endel/pilotage-endel.component';
import { PilotageMailsComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-mails/pilotage-mails.component';
import { PilotageAnalyseFinanciereComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-analyse-financiere/pilotage-analyse-financiere.component';
import { RelancesDocumentaireComponent } from './ECRANS/ADMINISTRATION/relances-documentaire/relances-documentaire.component';
import { LstDocumentairesComponent } from './ECRANS/LISTES/lst-documentaires/lst-documentaires.component';
import { PilotageSuiviAchatsComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-suivi-achats/pilotage-suivi-achats.component';
import { PilotageDocCommercialComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-suivi-achats/pilotage-doc-commercial/pilotage-doc-commercial.component';
import { CommentaireAchatsComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-suivi-achats/commentaire-achats/commentaire-achats.component';
import { FinancesComponent } from 'frontEndelScreens/FINANCES/finances-main/finances.component';
import { PilotageCriticiteComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-criticite/pilotage-criticite.component';
import { PilotageSuiviQualiteComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-suivi-qualite/pilotage-suivi-qualite.component';
import { PilotageDepensesComponent } from './ECRANS/PILOTAGE_ENDEL/pilotage-depenses/pilotage-depenses.component';
import { LstIntUsersComponent } from './ECRANS/ADMINISTRATION/lst-int-users/lst-int-users.component';
import { NonAdminLockPanelComponent } from './ECRANS/ADMINISTRATION/non-admin-lock-panel/non-admin-lock-panel.component';
import { IntUserDetailComponent } from './COMPOSANTS/int-user-detail/int-user-detail.component';
import { IntUserWindowComponent } from './COMPOSANTS/int-user-window/int-user-window.component';
import { LstContactsComponent } from './ECRANS/ADMINISTRATION/lst-contacts/lst-contacts.component';
import { LstConnexionsComponent } from './ECRANS/ADMINISTRATION/lst-connexions/lst-connexions.component';

import { LockedUserComponent } from './ECRANS/locked-user/locked-user.component';
import { LoggedOutAzureComponent } from './ECRANS/logged-out-azure/logged-out-azure.component';
import { AzureLogoutBtnComponent } from './COMPOSANTS/azure-logout-btn/azure-logout-btn.component';
import { LogoutComponent } from './ECRANS/logout/logout.component';
import { LoginCallbackComponent } from './ECRANS/login-callback/login-callback.component';
import { PafHeaderComponent } from './COMPOSANTS/paf-header/paf-header.component';
import { CadeauPierreComponent } from './ymo-message/ymo-message.component';
import { SvgIconComponent } from './COMMON/svg-icon/svg-icon.component';
import { FinancesDetailCmdsComponent } from './ECRANS/FINANCES/finances-detail-cmds/finances-detail-cmds.component';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 
          || window.navigator.userAgent.indexOf("Trident/") > -1;

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: azureEnvironnent.clientId,
      authority: azureEnvironnent.authority,
      redirectUri: azureEnvironnent.redirectUri,
      postLogoutRedirectUri: azureEnvironnent.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: isIE
    }
  });
}


@NgModule({
  declarations: [
    AppComponent,
    SearchSuppliersListComponent,
    NewSupplierComponent,
    HomeComponent,
    ExtusersListsComponent,
    SourcingComponent,
    LstTasksComponent,
    LstEncoursComponent,
    PilotageEndelComponent,
    PilotageMailsComponent,
    PilotageAnalyseFinanciereComponent,
    RelancesDocumentaireComponent,
    LstDocumentairesComponent,
    PilotageSuiviAchatsComponent,
    PilotageDocCommercialComponent,
    CommentaireAchatsComponent,
    FinancesComponent,
    PilotageCriticiteComponent,
    PilotageSuiviQualiteComponent,
    PilotageDepensesComponent,
    LstIntUsersComponent,
    NonAdminLockPanelComponent,
    IntUserDetailComponent,
    LstContactsComponent,
    LstConnexionsComponent,
    IntUserWindowComponent,
    LockedUserComponent,
    LstContactsComponent,
    LstConnexionsComponent,
    LoggedOutAzureComponent,
    AzureLogoutBtnComponent,
    LogoutComponent,
    LoginCallbackComponent,
    PafHeaderComponent,
    CadeauPierreComponent,
    SvgIconComponent,
    FinancesDetailCmdsComponent  
  ],
  imports: [
    SharedDataModule.forRoot(pafEnvironment),
    PafCommonModule,
    BrowserModule,
    FormsModule,
    OverlayModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    MsalModule.forRoot(
      MSALInstanceFactory(),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['user.read']
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          [azureEnvironnent.apiBaseUrl + '*', azureEnvironnent.protectedResourceScopes]
        ])
      }
    )
  ],
  providers: [
    { 
      provide: ENV, useValue: pafEnvironment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
  },
  MsalGuard,
  MsalService,
    {provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi:true},
    {provide: HTTP_INTERCEPTORS, useClass: LockedUserInterceptor, multi:true},
    {provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi:true},
    {provide: LOCALE_ID, useValue:'fr-FR'},
    { provide: IntlService, useClass: CldrIntlService },
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
